<div class="manage-users m-auto mt-5">
  <section class="card shadow-sm-darker mb-4">
    <form #addUser="ngForm" name="addUser" (ngSubmit)="addStudent()" class="mb-0">
      <h3 class="card-header mb-0">Add Student</h3>
      <div class="card-body">
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="email">Enter Email <span class="requiredfield">*</span></label>
          <input type="email" class="text-field" ngModel #email name="email" id="email" required>
        </div>
        <div class="fieldset mx-0 my-3" *ngIf="allowBatches">
          <label class="legend">Batch</label>
          <select class="text-field" (change)="setBatchId($event.target.value)">
            <option *ngFor="let batch of batches" [value]="batch.params.id">{{batch.displaytext}}</option>
          </select>
        </div>
      </div>

      <div class="card-footer">
        <button type="submit" [disabled]="!addUser.form.valid" class="btn">Add User</button>
      </div>
    </form>
  </section>
</div>
